<template>
<v-container class="app-page-container">
	<v-card class="shadow-none app-page-card">
        <div v-if="needInit && getLanguageIcons && user">{{initData()}}</div>
        <v-flex xs12 v-if="!needInit">
            <v-card v-if="allContent && allContent.length>0">   
                <v-card-text v-if="editIndex>-1 || showIndex > -1">
                    <v-alert :type="message_type">
                        {{allContent[editIndex>-1?editIndex:showIndex].title}}
                    </v-alert>
                </v-card-text>
                <v-card-text>
                    <v-select                    
                        v-model="message_type"
                        :items="message_types"
                        label="Type of message:"
                        outlined
                        @input="saveMessageType()"
                        >
                    </v-select>
                </v-card-text>
                <v-card-text>
                    <v-container> 
                        <v-row>
                            <v-flex class="language__translator-group vertically-horizontally-centered" data-title="translated">
                                <span v-for="(language,index) in allContent" :key=index class="translator-group__item">
                                    <img v-if="language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.language_id-1].url"
                                    @click ="showIndex = index"
                                    /> 
                                </span>    
                            </v-flex>
                            <v-flex class="language__translator-group vertically-horizontally-centered" data-title="not translated">
                                <span v-for="(language,index) in allContent" :key=index class="translator-group__item">
                                    <img v-if="!language.translated" class="translator-group__lang-icon cursor-pointer" :src="getLanguageIcons[language.language_id-1].url"
                                    @click ="editIndex = index"
                                    />
                                </span>    
                            </v-flex>
                        </v-row>

                        <v-row class="pa-2">    
                            <v-flex xs12 v-if="showIndex > -1" class="mb-5">
                                <v-card class="shadow-none card-border-style">
                                    <v-card-text class="pa-0 language__translator-element">
                                            <v-icon class="btn-close" @click="showIndex = -1" dense>close</v-icon> 

                                            <div class="language__translator-action-panel">
                                                <img class="lang-icon" :src="getLanguageIcons[showIndex].url">
                                                <v-icon @click="editIndex = showIndex; showIndex = -1;" dense>edit</v-icon>
                                            </div>

                                            <div class="language__translator-content">
                                                <b> {{allContent[showIndex].title}} </b>
                                                <br />
                                                {{allContent[showIndex].description}}
                                            </div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <v-flex xs12 v-if="editIndex > -1">
                                <v-card class="shadow-none card-border-style">
                                    <v-card-text class="pa-0 language__translator-element">

                                        <v-icon class="btn-close" @click="editIndex = -1" dense>close</v-icon>  

                                        <div class="language__translator-action-panel">
                                                <img class="lang-icon" :src="getLanguageIcons[editIndex].url">
                                        </div>

                                        <div class="language__translator-content">
                                                <v-text-field                                
                                                            label="Title"
                                                            v-model="allContent[editIndex].title"
                                                ></v-text-field>
                                                <v-textarea
                                                    label="Description (HTML):"
                                                    v-model="allContent[editIndex].description"
                                                    filled flat outlined :rows="3"                    
                                                ></v-textarea>
                                                <v-btn small @click="saveElement()" class="btn-style btn-primary">OK</v-btn>
                                        </div>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-row>
                    </v-container>
                </v-card-text>         
            </v-card>
        </v-flex>    
  </v-card>
</v-container>
</template>

<script>
import axios from '../../axios-auth.js'
import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        needInit : false,
        allContent : null,
        message_id: 0,
        showIndex : -1,
        editIndex: -1,
        channame: '',
        page: 1,
        my_qid: -1,
        message_type: 'info',
        message_types: ['success','info','warning','error']
      }
    },
    computed: 
        mapGetters([
                        'getLanguageIcons',
                        'user'
                    ])
    ,
    mounted() {
        this.needInit = true
    },
   methods: {
    initData() {
        this.needInit = false  
        this.$store.commit('setFeedback', null)
        this.allContent = []
        this.message_id = this.$route.params.id
        if (this.message_id == 0) {
            this.prepareEmptyContent()
        } else {
            this.getContent()
        }
    },
    getElement(_id, _message_id, _lang_id, _translated, _title, _description) {
        return {id: _id, message_id: _message_id, language_id: _lang_id, translated: _translated, title: _title, description: _description };
    },
    prepareEmptyContent() {        
        for(let i = 0; i < this.getLanguageIcons.length; i++) {
            this.allContent.push(this.getElement(0,0, this.getLanguageIcons[i].id, false, '', ''))
        }
    },
    getContent() {
        axios.get('/get-admin-message/' + this.message_id, this.$store.getters.getAxiosConfig)
            .then(res => {       
                this.message_type = this.message_types[res.data.message_type-1]
                var found = false         
                for(let i = 0; i < this.getLanguageIcons.length; i++) {
                    found = false
                    for (let j = 0; j < res.data.list.length; j++) {
                        if (this.getLanguageIcons[i].id == res.data.list[j].language_id) {
                            this.allContent.push(this.getElement(res.data.list[j].id, 
                                    res.data.list[j].message_id, this.getLanguageIcons[i].id, true, 
                                    res.data.list[j].title, res.data.list[j].description))
                            if (this.user.lang_id == this.getLanguageIcons[i].id) this.showIndex = i
                            found = true                      
                            break
                        }
                    }
                    if (!found) this.allContent.push(this.getElement(0, this.message_id, 
                                                         this.getLanguageIcons[i].id, false,'',''))
                }
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })
        },
    saveElement() {
        const edited = this.editIndex
        const data = {
            message_id: this.message_id,
            id: this.allContent[edited].id,
            language_id: this.allContent[edited].language_id,
            message_type: this.message_types.indexOf(this.message_type) + 1,
            title: this.allContent[edited].title,
            description: this.allContent[edited].description
        }
        axios.post('/save-message', data, this.$store.getters.getAxiosConfig)
            .then(res => {                
                this.message_id = res.data.message_id
                this.allContent[edited].id = res.data.id
                this.allContent[edited].translated = true; 
                this.editIndex = -1
                this.showIndex = edited
            })
            .catch(error => {
                this.$store.commit('setFeedback', error)          
            })
        },
        saveMessageType() {
            if (this.message_id == 0)  return
            const data = {
                message_id : this.message_id,
                message_type: this.message_types.indexOf(this.message_type) + 1,
            }
            axios.post('/save-message-type', data, this.$store.getters.getAxiosConfig)
                .then(() => {             
                })
                .catch(error => {
                    this.$store.commit('setFeedback', error)          
                })
        },
   }
}
   
  
</script>